export const LOGINLOADING = "LOGINLOADING";
export const LOGINSUCCESS = "LOGINSUCCESS";
export const PROFILEUPDATESUCCESS = "PROFILEUPDATESUCCESS";
export const PROFILEUPDATEFAILED = "PROFILEUPDATEFAILED";
export const PROFILEUPDATERESET = "PROFILEUPDATERESET";
export const LOGINERROR = "LOGINERROR";
export const SIGNOUTSUCCESS = "SIGNOUTSUCCESS";
export const SEARCHSUCCESS = "SEARCHSUCCESS";
export const USERDATAUPDATE = "USERDATAUPDATE";


export const ORDERLOADING = "ORDERLOADING";
export const ORDERSUCCESS = "ORDERSUCCESS";
export const ORDERFAILED = "ORDERFAILED";
export const ORDERERROR = "ORDERERROR";
export const ORDERRESET = "ORDERRESET";


export const GIFTLOADING = "GIFTLOADING";
export const GIFTSUCCESS = "GIFTSUCCESS";
export const GIFTFAILED = "GIFTFAILED";
export const GIFTERROR = "GIFTERROR";
export const GIFTRESET = "GIFTRESET";

export const TICKETLOADING = "TICKETLOADING";
export const TICKETSUCCESS = "TICKETSUCCESS";
export const TICKETFAILED = "TICKETFAILED";
export const TICKETERROR = "TICKETERROR";
export const TICKETRESET = "TICKETRESET";

export const MONEYLOADING = "MONEYLOADING";
export const MONEYSUCCESS = "MONEYSUCCESS";
export const MONEYFAILED = "MONEYFAILED";
export const MONEYERROR = "MONEYERROR";
export const MONEYRESET = "MONEYRESET";


export const NEWSLOADING = "NEWSLOADING";
export const NEWSSUCCESS = "NEWSSUCCESS";
export const NEWSERROR = "NEWSERROR";
